import { useMemo } from 'react';
import { usePluginMap } from './usePluginMap.mjs';

function useEnabledToolbarEntries(entries, plugins) {
  const pluginMap = usePluginMap(plugins);
  return useMemo(() => filterEnabled(entries, pluginMap), [entries, pluginMap]);
}
function filterEnabled(entries, pluginMap) {
  return entries.reduce((groups, group) => {
    const sections = group.reduce((acc, section) => {
      const items = section.reduce((plugins, component) => {
        const plugin = pluginMap.get(component.pluginType);
        if (plugin) {
          return [...plugins, {
            component,
            plugin
          }];
        }
        return plugins;
      }, []);
      if (!items.length) {
        return acc;
      }
      return [...acc, items];
    }, []);
    if (!sections.length) {
      return groups;
    }
    return [...groups, sections];
  }, []);
}

export { useEnabledToolbarEntries };
